export default "__VITE_ASSET__Dl3a0Wmq__"